export default defineAppConfig({
  ui: {
    colors: {
      primary: 'cyan',
      secondary: 'violet',
      neutral: 'slate',
      success: 'emerald',
      warning: 'amber',
      error: 'rose',
      // info: 'violet',
    },
    container: {
      base: 'w-full max-w-5xl xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
    },
    button: {
      defaultVariants: {
        variant: 'outline',
      },
      variants: {
        variant: {
          outline: 'bg-primary/5',
        },
      },
    },
    input: {
      variants: {
        variant: {
          outline: 'text-highlighted bg-slate-100 dark:bg-slate-800 ring ring-inset ring-accented',
        },
      },
    },
    select: {
      variants: {
        variant: {
          outline: 'text-highlighted bg-slate-100 dark:bg-slate-800 ring ring-inset ring-accented',
        },
      },
    },
    radioGroup: {
      defaultVariants: {
        variant: 'table',
      },
    },
    checkboxGroup: {
      defaultVariants: {
        variant: 'table',
      },
    },
    slideover: {
      slots: {
        header: 'pt-[max(1rem,env(safe-area-inset-top))]',
        close: 'top-[max(1rem,env(safe-area-inset-top))]',
      },
    },
    modal: {
      slots: {
        header: 'pt-[max(1rem,env(safe-area-inset-top))]',
        close: 'top-[max(1rem,env(safe-area-inset-top))]',
      },
    },
    selectMenu: {
      variants: {
        variant: {
          outline: 'text-highlighted bg-slate-100 dark:bg-slate-800 ring ring-inset ring-accented',
        },
      },
    },
  },
});
